// src/i18n.ts

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import srTranslations from './locales/sr.json';
import srLatinTranslations from './locales/srl.json';


i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      sr: { translation: srTranslations },
      srl: {translation: srLatinTranslations },
    },
    lng: 'sr', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;